import { AddressProps, ProfileProps, QuotationRequestItemProps } from '@/types'
import * as Yup from 'yup'

export const checkIsCompleteCreateGeneralInformation = ({
  address,
  buyerProfile,
}: {
  buyerProfile?: Partial<ProfileProps>
  address?: Partial<AddressProps>
}) => {
  return !!address?.uuid && !!buyerProfile?.uuid
}

export const checkIsCompleteCreateSelectProducts = ({
  items,
  file,
  rawInformation,
}: {
  items:
    | Partial<QuotationRequestItemProps>[]
    | QuotationRequestItemProps[]
    | undefined
  file: string | undefined
  rawInformation: string | undefined
}) => {
  return (!!items && items?.length > 0) || !!file || !!rawInformation
}

export const shemaQuotationRequest = (t: (key: string) => string) => ({
  buyerProfileUuid: Yup.string().required(t('requiredMessage')),
  addressUuid: Yup.string().required(t('requiredMessage')),
  status: Yup.string().required(t('requiredMessage')),
  items: Yup.array().notRequired(),
  file: Yup.string().notRequired(),
  rawInformation: Yup.string().notRequired(),

  atLeastOne: Yup.mixed().when(
    ['items', 'file', 'rawInformation'],
    ([items, file, rawInformation], schema) => {
      if ((!items || items.length === 0) && !file && !rawInformation) {
        return schema.required(t('requiredMessage'))
      }
      return schema.notRequired()
    },
  ),
})
